import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    //mode: 'history',
    //base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Layout",
            component: () => import(/* webpackChunkName: "SideNavigation" */ "./layouts/SideNavigation.vue"),
            redirect: "Process",
            meta: { requiresAuth: true },
            children: [
                {
                    path: "Process",
                    name: "Process",
                    components: {
                        default: () => import(/* webpackChunkName: "ExperianProcess" */ "./views/ExperianProcess.vue"),
                    },
                    props: {
                        default: (route) => ({
                            providerId: route.params.providerId,
                            patientId: route.params.patientId,
                            accountId: route.params.accountId,
                            isPaid: route.params.isPaid,
                            inClaim: route.params.inClaim,
                            ageing: route.params.ageing,
                            accountStatus: route.params.accountStatus,
                            agedDaysMin: route.params.agedDaysMin,
                            agedDaysMax: route.params.agedDaysMax,
                            hasFinalAccount: route.params.hasFinalAccount,
                        }),
                    },
                },
            ],
        },
    ],
});

export default router;
